'use client';

import { PlanPeriod } from 'components';
import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

export interface PlanToggleProps {
    selectedPeriod: PlanPeriod;
    onPeriodChange: (period: PlanPeriod) => void;
}

const PlanToggleButton = ({
    selectedPeriod,
    onPeriodChange,
    period,
}: {
    selectedPeriod: PlanPeriod;
    onPeriodChange: (period: PlanPeriod) => void;
    period: PlanPeriod;
}) => {
    const isSelected = selectedPeriod === period;

    return (
        <button
            onClick={() => onPeriodChange(period)}
            aria-pressed={isSelected}
            className={`flex items-center justify-start px-6 py-1 rounded-full shrink-0 ${
                isSelected ? 'bg-blue-900' : 'bg-transparent hover:bg-gray-100'
            }`}
        >
            <Text asChild fontSize="sm" fontWeight="regular" className="m-0">
                <span
                    className={`text-center whitespace-nowrap ${
                        isSelected ? 'text-white font-semibold' : 'text-gray-900'
                    }`}
                >
                    {period === 'monthly' ? 'Monthly' : 'Annual 50%+ off'}
                </span>
            </Text>
        </button>
    );
};

export const PlanToggle = ({ selectedPeriod, onPeriodChange }: PlanToggleProps): JSX.Element => {
    return (
        <div className="bg-white flex items-start justify-center p-0 rounded-full w-[262px] shrink-0">
            <PlanToggleButton selectedPeriod={selectedPeriod} onPeriodChange={onPeriodChange} period="monthly" />
            <PlanToggleButton selectedPeriod={selectedPeriod} onPeriodChange={onPeriodChange} period="annual" />
        </div>
    );
};
